
@switch (ipType) {
  @case ('Patent') {
    <mat-icon    [ngClass]="['menu-icon-sizing', 'menu-icon-padding']" fontSet="material-icons-outlined" >lightbulb</mat-icon>
  }
  @case ('Trademark') {
    <mat-icon [ngClass]="['ip-icon-trademark-icon', 'menu-icon-sizing', 'menu-icon-padding', 'menu-icon-bold']">®</mat-icon>
  }
  @case ('Matter') {
    <mat-icon    [ngClass]="['menu-icon-sizing', 'menu-icon-padding']" fontSet="material-icons-outlined" >business_center</mat-icon>
  }
  @default {
    <mat-icon            [ngClass]="['menu-icon-sizing', 'menu-icon-padding']" fontSet="material-icons-outlined">book</mat-icon>
  }
}
